import { Badge, Box, Typography, Accordion, AccordionSummary, AccordionDetails, Stack } from '@mui/material'
import { DataGrid } from '@mui/x-data-grid'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { useBasePath } from 'components/Providers'
import { capitalize } from 'lodash'
import { ROWS_PER_PAGE_OPTIONS } from 'constants'
import ActionMenu from '../MyDevice/List/ActionMenu'

export default function InactiveAssigned({ expanded, onChange, showCampus }) {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const basePath = useBasePath()
  const list = useSelector(state => state.asset.needsAttention.inactiveAssigned) || []
  const assetType = useSelector(state => state.lookup.types?.filter(type => type.category === 'assetType') || [])
  const handleAction = (row, action) => {
    navigate(`${basePath}/${row.id}/assign`, { state: { action } })
  }

  const handleTransferClick = (row) => {
    navigate(`${basePath}/${row.id}/transfer`, { state: { action: 'transfer' } });
  };

  const columns = [
    ...(showCampus ? [{ field: 'campusId', headerName: t('Campus'), flex: 1, renderCell: p => p.row.campus?.name || '' }] : []),
    { field: 'assetNumber', headerName: t('Asset Number'), flex: 1, },
    { field: 'brand', headerName: t('Brand'), flex: 1, renderCell: p => capitalize(p.value || '') },
    { field: 'serialNumber', headerName: t('Serial Number'), flex: 1, },
    {
      field: 'name',
      headerName: t('Assignee'),
      flex: 1,
      renderCell: p => p.row.assignInfo?.name || '',
    },
    { field: 'typeId', headerName: t('Type'), flex: 1, renderCell: p => assetType.find(type => type.code === p.value)?.name || '' },
    {
      field: 'actions',
      headerName: t('Actions'),
      flex: 1,
      sortable: false,
      renderCell: p => (
        <ActionMenu
          options={[
            { label: 'Transfer', visible: true, action: () => handleTransferClick(p.row) },
            { label: 'Return', visible: true, action: () => handleAction(p.row, 'return') },
            { label: 'Lost', visible: true, action: () => handleAction(p.row, 'lost') },
            { label: 'Deprovisioned', visible: true, action: () => handleAction(p.row, 'deprovisioned') },
          ]}
        />
      ),
    },
  ]

  return (
    <Accordion expanded={expanded} onChange={onChange}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Stack direction={'row'} alignItems={'center'} >
          <Typography variant="body1" fontWeight={600}>{t('Inactive Staff/Student with Assigned Devices')}</Typography>
          <Badge badgeContent={list.length} color="error" sx={{ ml: 3 }}><Box /></Badge>
        </Stack>
      </AccordionSummary>
      <AccordionDetails>
        <DataGrid
          rows={list}
          columns={columns}
          pageSizeOptions={ROWS_PER_PAGE_OPTIONS}
          disableRowSelectionOnClick
          autoHeight
          initialState={{ pagination: { paginationModel: { pageSize: 10 } } }}
        />
      </AccordionDetails>
    </Accordion>
  )
}
